(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.__spInit) return;
    root.__spInit = true;

    var form = root.querySelector('.sp-form');
    var overlay = root.querySelector('[data-sp-overlay]');
    var auto = root.getAttribute('data-auto') === 'true';
    if (!form) return;

    function open() {
      form.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.documentElement.classList.add('sp-lock');
    }
    function close() {
      form.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.documentElement.classList.remove('sp-lock');
    }
    function go() {
      var inputs = form.querySelectorAll('input[type="number"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === '') inputs[i].disabled = true;
      }
      form.submit();
    }

    var openers = root.querySelectorAll('[data-sp-open]');
    for (var a = 0; a < openers.length; a++) openers[a].addEventListener('click', open);
    var closers = root.querySelectorAll('[data-sp-close]');
    for (var b = 0; b < closers.length; b++) closers[b].addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var sort = root.querySelector('[data-sp-sort]');
    if (sort) sort.addEventListener('change', go);

    var apply = root.querySelector('[data-sp-apply]');
    if (apply) apply.addEventListener('click', go);

    form.addEventListener('submit', function () {
      var inputs = form.querySelectorAll('input[type="number"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === '') inputs[i].disabled = true;
      }
    });

    if (auto) {
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t && (t.type === 'checkbox' || t.type === 'number')) go();
      });
    }

    /* if the window grows to desktop while the drawer is open, reset it */
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990 && root.classList.contains('sp--sidebar')) close();
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-sp]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
